import type { QueryBuilder } from "@cgarciagarcia/react-query-builder";
import { createQueryKeys } from "@lukemorales/query-key-factory";

import {
  convertProviderSlot,
  deleteProviderSchedule,
  getAdminProviders,
  getProviderAppointments,
  getProviderScheduleMeta,
  getProviderSlots,
  uploadProviderSchedule,
} from "./api";
import type { ProviderSlotFilters } from "./types";

export const queries = createQueryKeys("adminProviders", {
  list: ({
    queryBuilder,
  }: {
    queryBuilder?: QueryBuilder<Record<string, string> | undefined>;
  }) => ({
    queryKey: ["adminProviders", queryBuilder?.toArray()],
    queryFn: () => getAdminProviders({ queryBuilder }),
  }),

  scheduleMeta: (providerId: string) => ({
    queryKey: ["adminProvider", providerId, "scheduleMeta"],
    queryFn: () => getProviderScheduleMeta(providerId),
  }),
  slots: ({
    providerId,
    startDate,
  }: {
    providerId: string;
    startDate: string;
  }) => ({
    queryKey: ["adminProvider", providerId, "slots", startDate],
    queryFn: async () =>
      (await getProviderSlots({ providerId, startDate })).data,
  }),

  slotsInfinite: ({
    providerId,
    visitTypes,
    statuses,
  }: { providerId: string } & ProviderSlotFilters) => ({
    queryKey: [
      "adminProvider",
      providerId,
      "slots",
      "all",
      visitTypes,
      statuses,
    ],
  }),

  orphanedAppointments: (providerId: string) => ({
    queryKey: ["providerAppointments", providerId, "orphaned"],
    queryFn: () =>
      getProviderAppointments({
        providerId,
        orphaned: true,
      }),
  }),
});

export const mutations = {
  uploadProviderSchedule,
  deleteProviderSchedule,
  convertProviderSlot,
};
